import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { RequisitionTask } from '../../../class/requisition-task';
import { RequisitionTaskService } from '../../../service/requisition-task/requisition-task.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-new-requisition-task',
  templateUrl: './new-requisition-task.component.html',
  styleUrls: ['./new-requisition-task.component.scss']
})
export class NewRequisitionTaskComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: RequisitionTask;
    @Input() requisitionId: number;
    public promiseForm: Promise<any>;
    public form: FormGroup;

    public task: AbstractControl;
    public employee_id: AbstractControl;
    public status: AbstractControl;
    public optionsSelectionStatus: any[];                            
    public es: any;

    public save_exit: boolean;
    public employeePositionToLoad: string;

    constructor(
        fb: FormBuilder,
        public requisitionTaskService: RequisitionTaskService,
        public translate: TranslateService,
        private notificationsService: NotificationsService) {

        this.save_exit = false;
        this.employeePositionToLoad = '5,6,7,8,9,10,21,24,25,38,53';

        this.es = calendarES();

        this.optionsSelectionStatus = [];
            this.optionsSelectionStatus.push({label: 'Abierta', value: 'Abierta'});
            this.optionsSelectionStatus.push({label: 'Cerrada', value: 'Cerrada'});
        
        this.form = fb.group({
            'task': ['', Validators.compose([Validators.required])],
            'employee_id': ['', Validators.compose([Validators.required])],
            'status': ['', Validators.compose([Validators.required])],                                                                                            
        });

        
        this.task = this.form.controls['task'];
        this.employee_id = this.form.controls['employee_id'];
        this.status = this.form.controls['status'];                                                            
    }

    ngOnInit() {
        if (this.edit) {
            this.task.setValue(this.edit.task);
            this.employee_id.setValue(this.edit.employee_id);
            this.status.setValue(this.edit.status);                                                                                            
        } else {
            // this.activated.setValue(true);
        }
    }

    public cancelRequisitionTask () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newRequisitionTask(values);
    }

    public newRequisitionTask(values) {
        const param = {
            'task': values.task,
            'employee_id': values.employee_id.id,
            'requisition_id': this.requisitionId,                                    
            'status': values.status,     
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.requisitionTaskService.updateRequisitionTask(this.edit.id, param)
                :
                this.requisitionTaskService.newRequisitionTask(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    // public formatDate(date) {
    //     const d = new Date(date);
    //     let month = '' + (d.getMonth() + 1);
    //     let day = '' + d.getDate();
    //     const year = d.getFullYear();
    //     let hours = '' + d.getHours();
    //     let minutes = '' + d.getMinutes();
    //     let seconds = '' + d.getSeconds();

    //     if (month.length < 2) {
    //         month = '0' + month;
    //     }
    //     if (day.length < 2) {
    //         day = '0' + day;
    //     }

    //     if (hours.length < 2) {
    //         hours = '0' + hours;
    //     }

    //     if (minutes.length < 2) {
    //         minutes = '0' + minutes;
    //     }

    //     if (seconds.length < 2) {
    //         seconds = '0' + seconds;
    //     }

    //     return [year, month, day].join('-');
    // }

    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/requisition-tasks/new-requisition-task/new-requisition-task.component.ts